import React, { useState, useEffect } from 'react';

import helpers from 'helpers';

import { letterMapper, AnnotationTooltip } from 'helpers/annotations';
import { renderUsefulLines } from './utils';

const ContentAnnotations = ({ 
    textLetter, 
    annotations,
    predictorData,
    showUsefulLines,
}) => {
    const [characters, setCharacters] = useState();
    const [tooltips, setTooltips] = useState();

    useEffect(() => {
        if (annotations.length > 0) {
            const newCharacters = createCharacters(textLetter, annotations);
            const newTooltips = createTooltips(newCharacters);

            setCharacters(newCharacters);
            setTooltips(newTooltips);
        } else {
            setCharacters(undefined);
            setTooltips(undefined);
        }
    }, [textLetter, annotations]);

    const createCharacters = (textLetter, annotations) => {
        let characters = textLetter.split('');

        characters = characters.map((symbol, symbolPosition) => {
            symbol = symbol === ' ' ? '\u00A0' : symbol;

            return {
                symbol,
                symbolPosition,
                style: {},
                ids: [],
                tooltipContent: [],
            };
        });

        const sortedAnnotations = [...annotations].sort((a, b) => {
            if (a.priority > b.priority) {
                return -1;
            }

            if (a.priority < b.priority) {
                return 1;
            }

            return 0;
        });

        for (let i = 0; i < sortedAnnotations.length; i++) {
            const hashColor = helpers.createHashColor();

            for (let j = sortedAnnotations[i].start; j < sortedAnnotations[i].end; j++) {
                if (sortedAnnotations[i].styles.background === '') {
                    characters[j].style = {
                        ...sortedAnnotations[i].styles,
                        background: hashColor,
                    };
                } else {
                    characters[j].style = sortedAnnotations[i].styles;
                }

                characters[j].ids.push(sortedAnnotations[i].id);
                characters[j].tooltipContent.push({
                    rule: sortedAnnotations[i].features.rule,
                    type: sortedAnnotations[i].type,
                });
            }
        }

        return characters;
    };

    const createTooltips = (characters) => {
        const map = new Map();
        characters.forEach((char) => {
            map.set(char.ids.join(''), char);
        });
        return Array.from(map.values());
    };

    return (
        <div>
            <div className='letter-text'>
                {
                    (() => {
                        if (showUsefulLines) {
                            return renderUsefulLines(predictorData, textLetter);
                        }
                        if (characters) {
                            return Array.from(letterMapper(characters));
                        }
                        return textLetter;
                    })()
                }
            </div>
            <AnnotationTooltip
                tooltips={tooltips}
                renderTooltip={tooltip => (
                    <div className='tooltip-row'>
                        {
                            tooltip.tooltipContent.map((t, k) => {
                                const rule = t.rule && `Rule - ${t.rule}, `;

                                return (
                                    <div key={k} className='tooltip-column'>
                                        <div className='col'>{rule}</div>
                                        <div className='col'>{`Type - ${t.type}`}</div>
                                    </div>
                                );
                            })
                        }
                    </div>
                )}
            />
        </div>
    );
};

export default ContentAnnotations;



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Content/Annotations.jsx